module.exports = __webpack_public_path__ + "assets/img/45e8affec5fd1cabcaedc9e2ab22504f.svg";